import { createContext } from 'react';

const contextName = 'SpaApdexAnalytics';
export default createContext(contextName);
